import React from 'react';

import { SubscriberProvider } from '../contextProvider/subscriberProvider.tsx';

export const withSubscriberContext = (Component) => {
    return (props) => {
        return <SubscriberProvider>
            <Component {...props}/>
        </SubscriberProvider>
    }
}